import { useQuery } from '@tanstack/react-query';
import { GET_DEFAULT_COMMENTS } from '@/helpers/query-keys';
import { getDefaultComments } from '@/services/qc.service';

type DefaultCommentType = 'public' | 'defect';

export const useDefaultComments = (type: DefaultCommentType) => {
  return useQuery({
    queryKey: [GET_DEFAULT_COMMENTS, type],
    queryFn: async () => {
      const data = await getDefaultComments(type);
      return data;
    },
    staleTime: Infinity,
  });
};
